module.exports = __webpack_public_path__ + "img/card03.42e679e2.png";